import { BaseApi } from './base.api.js';

export class ReportingArchiveApi extends BaseApi {
    constructor(client, basePath = '/reporting-archives') {
        super(client, basePath);
    }
}
